import { PickupStoreStock } from './PickupStoreStock';
export default PickupStoreStock;
